import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  public readonly appVersion: string = environment.appVersion;

  private apiVersion = new BehaviorSubject<string>(null);

  public getApiVersion(): Observable<string> {
    return this.apiVersion.asObservable();
  }

  public setApiVersion(version: string): void {
    this.apiVersion.next(version);
  }
}
